import AdminRoute from "./components/AdminRoute";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { useEffect } from "react";
import StatusFilterBar from "./components/StatusFilterBar";
import Layout from "./components/Layout";
import ProtectedRoute from "./components/ProtectedRoute";
import Login from "./pages/Login";
import GooglebotLogs from "./pages/GooglebotLogs";
import IndexingControl from "./pages/IndexingControl";
import Settings from "./pages/Settings";
import AddProject from "./pages/AddProject";
import ProjectView from "./pages/ProjectView";
import EditProject from "./pages/EditProject";
import AddLinks from "./pages/AddLinks";
import NotFound from "./pages/NotFound";
import Contactus from "./pages/Contactus";
import Register from "./pages/Register";
import APIIndexBooster from "./pages/APIIndexBooster";
import Profile from "./pages/Profile";
import Users from "./pages/Users";
import UserProjects from "./pages/UserProjects";
import { refreshToken } from "./utils/auth";
import { logout } from "./utils/auth";
import TaskManager from "./pages/TaskManager";
import CreditsHistory from "./pages/CreditsHistory";
import APILogs from "./pages/APILogs";
import CreditsHistoryAdmin from "./pages/CreditsHistoryAdmin";
import AllTasks from "./pages/AllTasks";
import AllProject from "./pages/AllProject";
import ActivateAccount from "./pages/ActivateAccount";
import ResendActivation from "./pages/ResendActivation";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import BuyCredits from "./pages/BuyCredits.js";
import PurchaseSuccess from "./pages/PurchaseSuccess.js";
import MyOrders from "./pages/MyOrders.js";
import AllOrders from "./pages/AllOrders.js";
import ManualIndexTasks from "./pages/ManualIndexTasks.js";



function App() {
  useEffect(() => {
    const interval = setInterval(refreshToken, 10 * 60 * 1000); // Обновление токена каждые 10 минут
    return () => clearInterval(interval);
  }, []);

  return (
    <Router>
      <Routes>
        <Route path="/activate" element={<ActivateAccount />} />
        <Route path="/resend-activation" element={<ResendActivation />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
	<Route path="/reset-password" element={<ResetPassword />} />
         <Route path="/registration" element={<Register />} />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Layout logout={logout}>
                <IndexingControl />
              </Layout>
            </ProtectedRoute>
          }
        />
<Route
  path="/credit-history"
  element={
    <ProtectedRoute>
        <Layout logout={logout}>
          <CreditsHistory />
        </Layout>
    </ProtectedRoute>
  }
/>
<Route
  path="/purchase-success"
  element={
    <ProtectedRoute>
        <Layout logout={logout}>
          <PurchaseSuccess />
        </Layout>
    </ProtectedRoute>
  }
/>
<Route
  path="/my-orders"
  element={
    <ProtectedRoute>
        <Layout logout={logout}>
          <MyOrders />
        </Layout>
    </ProtectedRoute>
  }
/>
<Route
  path="/buy-credits"
  element={
    <ProtectedRoute>
        <Layout logout={logout}>
          <BuyCredits />
        </Layout>
    </ProtectedRoute>
  }
/>
<Route
  path="/credit-history-admin"
  element={
    <ProtectedRoute>
      <AdminRoute>
        <Layout logout={logout}>
          <CreditsHistoryAdmin />
        </Layout>
      </AdminRoute>
    </ProtectedRoute>
  }
/>


<Route
  path="/all-project"
  element={
    <ProtectedRoute>
      <AdminRoute>
        <Layout logout={logout}>
          <AllProject />
        </Layout>
      </AdminRoute>
    </ProtectedRoute>
  }
/>
<Route
  path="/all-tasks"
  element={
    <ProtectedRoute>
      <AdminRoute>
        <Layout logout={logout}>
          <AllTasks />
        </Layout>
      </AdminRoute>
    </ProtectedRoute>
  }
/>
<Route
  path="/all-orders"
  element={
    <ProtectedRoute>
      <AdminRoute>
        <Layout logout={logout}>
          <AllOrders />
        </Layout>
      </AdminRoute>
    </ProtectedRoute>
  }
/>
<Route
  path="/users"
  element={
    <ProtectedRoute>
      <AdminRoute>
        <Layout logout={logout}>
          <Users />
        </Layout>
      </AdminRoute>
    </ProtectedRoute>
  }
/>

<Route
  path="/user/:userId/projects"
  element={
    <ProtectedRoute>
      <AdminRoute>
        <Layout logout={logout}>
          <UserProjects />
        </Layout>
      </AdminRoute>
    </ProtectedRoute>
  }
/>

<Route
  path="/logs"
  element={
    <ProtectedRoute>
      <AdminRoute>
        <Layout logout={logout}>
          <GooglebotLogs />
        </Layout>
      </AdminRoute>
    </ProtectedRoute>
  }
/>

<Route
  path="/task-manager"
  element={
    <ProtectedRoute>
      <AdminRoute>
        <Layout logout={logout}>
          <TaskManager />
        </Layout>
      </AdminRoute>
    </ProtectedRoute>
  }
/>

<Route
  path="/settings"
  element={
    <ProtectedRoute>
      <AdminRoute>
        <Layout logout={logout}>
          <Settings />
        </Layout>
      </AdminRoute>
    </ProtectedRoute>
  }
/>
<Route
  path="/manual-index-tasks"
  element={
    <ProtectedRoute>
      <AdminRoute>
        <Layout logout={logout}>
          <ManualIndexTasks />
        </Layout>
      </AdminRoute>
    </ProtectedRoute>
  }
/>
<Route
  path="/api-logs"
  element={
    <ProtectedRoute>
      <AdminRoute>
        <Layout logout={logout}>
          <APILogs />
        </Layout>
      </AdminRoute>
    </ProtectedRoute>
  }
/>
        <Route
          path="/indexing/add"
          element={
            <ProtectedRoute>
              <Layout logout={logout}>
                <AddProject />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/project/:id"
          element={
            <ProtectedRoute>
              <Layout logout={logout}>
                <ProjectView />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/project/:id/edit"
          element={
            <ProtectedRoute>
              <Layout logout={logout}>
                <EditProject />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/project/:id/add-links"
          element={
            <ProtectedRoute>
              <Layout logout={logout}>
                <AddLinks />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/contact-us"
          element={
            <ProtectedRoute>
              <Layout logout={logout}>
                <Contactus />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/api-indexbooster"
          element={
            <ProtectedRoute>
              <Layout logout={logout}>
                <APIIndexBooster />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/profile"
          element={
            <ProtectedRoute>
              <Layout logout={logout}>
                <Profile />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
